<template>
  <div class="hCardBody">
    <el-card class="hCard" :body-style="{ padding: '10px' }">
      <!-- {{ itemRow }} -->
      <el-checkbox
        class="hCheckbox"
        v-model="itemRow.is"
        @change="checkBoxChange"
      ></el-checkbox>
      <!-- <img :src="itemRow.imagePartUrl" /> -->
      <h-more-btn
        :itemRowIndex="itemRowIndex"
        :itemRow="itemRow"
        @imageListUrl="imageListUrl"
        :moreSelect="moreSelect"
      ></h-more-btn>
      <div>
        <el-tooltip placement="left" :content="itemRow.deviceName">
          <div class="topTooltip">{{ itemRow.deviceName }}</div>
        </el-tooltip>
        <el-tooltip
          placement="left"
          :content="formatDateHMSSJC(itemRow.snapTime)"
        >
          <div class="topTooltip">{{ formatDateHMSSJC(itemRow.snapTime) }}</div>
        </el-tooltip>
      </div>
    </el-card>
  </div>
</template>
<script>
import {
  defineComponent,
  watchEffect,
  onMounted,
  nextTick,
  reactive,
  toRefs,
  toRaw,
  ref,
} from "vue";
import { formatDateHMSSJC } from "@/utils/index.js";
export default defineComponent({
  name: "HCard",
  props: {
    itemRow: {},
    moreSelect: {
      type: Array,
      default: () => [],
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    itemRowIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const data = reactive({
      defaultOpen: true,
      moreOperation: false, // 展示更多操作
      moreFalse: false,
      moreSelectList: [
        { name: "查看大图", icon: "icon-fangda", path: "" },
        { name: "下载", value: "icon-shexiangtou1", path: "" },
        { name: "身份稽查", value: "icon-shenfenzheng", path: "" },
        // { name: "落脚点分析", value: "icon-navigation_e", path: "" },
        // { name: "人员详情", value: "icon-paixu", path: "" },
        // { name: "视图研判", value: "icon-yanpanmoxing", path: "" },
        // { name: "同行分析", value: "icon-bansuitongxi", path: "" },
        // { name: "抓拍检索", value: "icon-biaoshilei_luxiang", path: "" },
        // { name: "1比1比对", value: "icon-beijingyibiyi", path: "" }
      ],
    });
    const checkBoxChange = (val) => {
      context.emit("checkBoxChange", props.itemRow, val);
    };
    watchEffect(() => {
      data.moreSelectList = data.moreSelectList.concat(props.moreSelect);
    });
    const handleMoreOperation = (item) => {
      data.moreOperation = true;
      data.showEareItem = item.value;
    };
    const handleMoreLeave = () => {
      data.moreOperation = false;
      data.moreFalse = false;
    };
    const moreClick = () => {
      data.moreFalse = true;
    };
    const moreClickList = (item) => {
      data.moreFalse = !data.moreFalse;
    };
    const imageListUrl = (item) => {
      context.emit("imageListUrl", item);
    };

    return {
      ...toRefs(data),
      imageListUrl,
      moreClickList,
      moreClick,
      checkBoxChange,
      handleMoreOperation,
      handleMoreLeave,
      formatDateHMSSJC,
    };
  },
});
</script>
<style lang="scss" scoped>
.hCardBody {
  height: 281px;
  width: 100%;
  /deep/ .el-card {
    overflow: visible !important;
    height: 250px;
    .el-card__body {
      overflow: visible !important;
    }
  }
  .hCard {
    height: 100%;
    padding: 20px;
    position: relative;

    // overflow: visible !important;
    .hCheckbox {
      position: absolute;
      left: 0;
      top: -9px;
    }
    .eareItemImg {
      position: relative;
      height: 80%;
      .el-image {
        height: 100%;
        width: 100%;
      }
      .downBtn {
        padding: 3px 5px;
        background: rgba(0, 0, 0, 0.5);
        // border-radius: 5px;
        position: absolute;
        width: 100%;
        top: 0;
        text-align: center;
        cursor: pointer;
      }
      .moreBtn {
        position: absolute;
        width: 100%;
        text-align: center;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        bottom: 0px;
        cursor: pointer;
      }
    }

    .topTooltip {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 30px;
      line-height: 30px;
      color: #333;
      font-size: 14px;
    }
  }
  .moreSelect {
    position: absolute;
    font-size: 14px;
    bottom: 21px;
    background: rgba(0, 0, 0, 1);
    width: 100%;
    max-height: 150px;
    overflow: auto;
    // border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }
}
</style>
